// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type TradeDetails } from '@shared/data-access/interfaces/redux/trades';
import { numberToFixed } from '@shared/ui-kit/utils';

export const getMape = (data: TradeDetails[]) => {
  let sumAbsoluteDelta = 0;
  let totalVolume = 0;
  let mape = 0;

  if (data.length === 0) {
    return mape;
  }

  data.forEach((stock: any) => {
    sumAbsoluteDelta += Math.abs(stock.delta_volume);
    totalVolume += stock.volume;
  });

  if (totalVolume !== 0) {
    mape = Math.round((sumAbsoluteDelta / totalVolume) * 10000) / 100;
  }

  return mape;
};

export const unavailableTrades = (data: TradeDetails[]) => {
  if (data.length === 0) {
    return false;
  }

  const areSomeTradeUnavailable = data.some(
    trade => !numberToFixed(trade.expected_price as number, 5),
  );

  return areSomeTradeUnavailable;
};

export const delay = (ms: number) => new Promise(res => setTimeout(res, ms));
